document.addEventListener("DOMContentLoaded", async () => {
  const root = document.getElementById("uncove-button");
  if (!root) return;

  const customerEmail = (root.dataset.customerEmail || "").trim().toLowerCase();
  const handle = (root.dataset.handle || "").trim();
  const defaultUrl = (root.dataset.defaultUrl || "https://uncove.com/@ohmygodz/search").trim();

  const labelOwner = root.dataset.labelOwner || "Découvrir Uncove";
  const labelVisitorWithLink = root.dataset.labelVisitorWithLink || "Découvrir sur Uncove";
  const labelVisitorNoLink = root.dataset.labelVisitorNoLink || "Découvrir Uncove (visiteur)";
  const openInNewTab = String(root.dataset.openNewTab) === "true";

  const widthMode = root.dataset.widthMode || "full";
  const maxWidth = parseInt(root.dataset.maxWidth || "400", 10);
  const fullMaxWidth = parseInt(root.dataset.fullMaxWidth || "480", 10);
  const mobileMaxWidth = parseInt(root.dataset.mobileMaxWidth || "320", 10);
  const fontSize = parseInt(root.dataset.fontSize || "16", 10);
  const paddingY = parseInt(root.dataset.paddingY || "12", 10);
  const paddingX = parseInt(root.dataset.paddingX || "18", 10);
  const radius = parseInt(root.dataset.radius || "8", 10);
  const marginTop = parseInt(root.dataset.marginTop || "24", 10);

  const variant = root.dataset.variant || "filled";
  const borderEnabled = String(root.dataset.borderEnabled) === "true";
  const borderColor = root.dataset.borderColor || "#111111";
  const borderHoverColor = root.dataset.borderHoverColor || borderColor;
  const borderWidth = parseInt(root.dataset.borderWidth || "1", 10);
  const bg = root.dataset.bg || "#111111";
  const hoverBg = root.dataset.hoverBg || "#2b2b2b";
  const textColor = root.dataset.text || "#ffffff";

  const includeLogo = String(root.dataset.includeLogo) === "true";
  const logoSize = parseInt(root.dataset.logoSize || "18", 10);
  const logoGap = parseInt(root.dataset.logoGap || "8", 10);
  const logoSrcFromSettings = (root.dataset.logoSrc || "").trim();

  const imageOnlyMode = String(root.dataset.imageOnlyMode) === "true";
  const imagePadding = parseInt(root.dataset.imagePadding || "8", 10);

  const sponsorTrigger = (root.dataset.sponsorTrigger || "je monétise mon contenu").trim();
  const sponsorUrl = (root.dataset.sponsorUrl || "https://sponsor.uncove.com/ohmygodz").trim();

  const uid = "uncove-btn-" + Math.random().toString(36).slice(2, 8);

  const styleWidth = widthMode === "full" ? "100%" : (widthMode === "auto" ? "auto" : "100%");
  const styleMaxW = widthMode === "custom" ? maxWidth + "px" : widthMode === "full" ? fullMaxWidth + "px" : "none";

  function render(label, href, logoUrl) {
    const norm = (s) => (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, " ").trim();
    const normLabel = norm(label);
    const normTrigger = norm(sponsorTrigger);

    if (normLabel.includes(normTrigger) || normTrigger.includes(normLabel) || /^je monetise/.test(normLabel)) {
      href = sponsorUrl;
    }

    if (imageOnlyMode && logoUrl) {
      const targetAttr = openInNewTab ? ' target="_blank" rel="noopener noreferrer"' : "";
      const imageStyles = [
        "display:inline-block",
        "padding:" + imagePadding + "px",
        "border-radius:" + radius + "px",
        "background-color:" + bg,
        "margin-top:" + marginTop + "px",
        "text-decoration:none",
        "line-height:0",
        "font-size:0",
        "transition:background-color .2s ease, transform .06s ease, border-color .2s ease"
      ];

      const hasBorder = variant === "outline" ? true : borderEnabled;
      imageStyles.push(hasBorder ? "border:" + borderWidth + "px solid " + borderColor : "border:" + borderWidth + "px solid transparent");

      const css = '<style id="' + uid + '-style">#' + uid + '{cursor:pointer;}#' + uid + ':hover{background-color:' + hoverBg + ' !important;' + (hasBorder ? 'border-color:' + borderHoverColor + ' !important;' : '') + '}#' + uid + ':active{transform:translateY(1px);}#' + uid + ' img{display:block;max-width:' + logoSize + 'px;height:auto;width:auto;}@media (max-width:640px){#' + uid + ' img{max-width:' + Math.min(logoSize, mobileMaxWidth - (imagePadding * 2)) + 'px;}}</style>';

      root.innerHTML = css + '<a id="' + uid + '" href="' + href + '"' + targetAttr + ' style="' + imageStyles.join(";") + '"><img src="' + logoUrl + '" alt="' + label + '" /></a>';
      return;
    }

    const baseStyles = [
      "display:inline-flex",
      "align-items:center",
      "justify-content:center",
      "width:" + styleWidth,
      styleMaxW !== "none" ? "max-width:" + styleMaxW : "",
      "margin-top:" + marginTop + "px",
      "padding:" + paddingY + "px " + paddingX + "px",
      "border-radius:" + radius + "px",
      "font-weight:500",
      "font-size:" + fontSize + "px",
      "line-height:1",
      "text-decoration:none",
      "font-family:inherit",
      "gap:" + (includeLogo ? logoGap + "px" : "0px"),
      "transition:background-color .2s ease, transform .06s ease, border-color .2s ease"
    ];

    const hasBorder = variant === "outline" ? true : borderEnabled;
    baseStyles.push("background-color:" + bg, "color:" + textColor, hasBorder ? "border:" + borderWidth + "px solid " + borderColor : "border:" + borderWidth + "px solid transparent");

    const targetAttr = openInNewTab ? ' target="_blank" rel="noopener noreferrer"' : "";
    const layoutBox = Math.max(12, fontSize);
    const logoContainerId = uid + "-logo";

    let logoHtml = "";
    if (includeLogo && logoUrl) {
      logoHtml = '<span id="' + logoContainerId + '" style="display:flex;align-items:center;justify-content:center;height:' + layoutBox + 'px;"><img src="' + logoUrl + '" alt="" style="height:' + logoSize + 'px;width:auto;object-fit:contain;display:block;" /></span>';
    }

    const css = '<style id="' + uid + '-style">#' + uid + ':hover{background-color:' + hoverBg + ' !important;' + (hasBorder ? 'border-color:' + borderHoverColor + ' !important;' : '') + '}#' + uid + ':active{transform:translateY(1px);}@media (max-width:640px){#' + uid + '{' + (widthMode === "full" ? 'max-width:' + mobileMaxWidth + 'px;' : '') + 'flex-direction:column;gap:6px;text-align:center;padding:' + (paddingY + 4) + 'px ' + (paddingX + 2) + 'px;}#' + uid + ' span{display:block;text-align:center;white-space:normal;}}</style>';

    root.innerHTML = css + '<a id="' + uid + '" href="' + href + '"' + targetAttr + ' style="' + baseStyles.join(";") + '"><span>' + label + '</span>' + logoHtml + '</a>';

    if (includeLogo && logoUrl) {
      const a = document.getElementById(uid);
      const img = document.querySelector("#" + logoContainerId + " img");
      if (!a || !img) return;

      const adjustPadding = () => {
        if (!img.naturalWidth) return;
        const btnRect = a.getBoundingClientRect();
        const logoRect = img.getBoundingClientRect();
        const overflow = (logoRect.right + 8) - btnRect.right;
        if (overflow > 0) {
          const currentPadding = parseInt(window.getComputedStyle(a).paddingRight, 10) || paddingX;
          a.style.paddingRight = (currentPadding + overflow) + "px";
        }
      };

      if (img.complete) adjustPadding();
      else img.addEventListener("load", adjustPadding, {once: true});
      window.addEventListener("resize", adjustPadding);
    }
  }

  if (!handle) return render(labelVisitorNoLink, defaultUrl, logoSrcFromSettings);

  let info;
  try {
    const res = await fetch("/apps/wishlist/proxy/partner-info?handle=" + encodeURIComponent(handle), {method: "GET", credentials: "same-origin"});
    info = await res.json();
  } catch {
    info = {partner: {email: null, externalLink: null, logoUrl: null}};
  }

  const partnerEmail = (info?.partner?.email || "").toLowerCase();
  const externalLink = info?.partner?.externalLink || null;
  const logoFromAPI = info?.partner?.logoUrl || null;
  const logoUrl = logoSrcFromSettings || logoFromAPI;

  if (customerEmail && partnerEmail && customerEmail === partnerEmail) {
    render(labelOwner, defaultUrl, logoUrl);
  } else if (externalLink) {
    render(labelVisitorWithLink, externalLink, logoUrl);
  } else {
    render(labelVisitorNoLink, defaultUrl, logoUrl);
  }
});